export type Language = 'zh' | 'en' | 'de' | 'fr' | 'ja' | 'ko' | 'ar';

export interface Translations {
  // Header
  logoSubtitle: string;
  tagline: string;
  langName: string;

  // Hero
  heroTitle: string;
  heroSubtitle: string;

  // Labels
  growing: string;
  comingSoon: string;

  // Categories
  categoryAll: string;
  categoryContentCreation: string;
  categoryDesign: string;
  categoryResearch: string;
  categoryCareer: string;
  categoryEducation: string;
  categoryLifestyle: string;
  categoryMarketing: string;
  categoryCreative: string;
  categoryProductivity: string;
  categoryCommunity: string;
  categoryDevTools: string;

  // Tools
  tools: {
    name: string;
    description: string;
    category: string;
  }[];

  // Stats
  statsTools: string;
  statsAI: string;
  statsOnline: string;

  // Footer
  footerMadeWith: string;
  footerCopyright: string;
  footerGithub: string;
  footerFeedback: string;
}

export const translations: Record<Language, Translations> = {
  // ===== 中文 =====
  zh: {
    logoSubtitle: 'AI 原生时代的个人创作旷野，让思想者拥有自己的空间与灵魂，成为去中心化创作者生态的「母港」。无追踪，无侵扰，无弹窗，不迎合流量、不贩卖焦虑、不打扰每一份纯粹的思考',
    tagline: 'AI工具集合',
    langName: '中文',

    heroTitle: 'AI驱动的原创工具集合',
    heroSubtitle: '21个精选AI工具，让你的工作生活更精彩',

    growing: '生长中',
    comingSoon: '敬请期待',

    categoryAll: '全部',
    categoryContentCreation: '内容创作',
    categoryDesign: '设计工具',
    categoryResearch: '研究分析',
    categoryCareer: '职业发展',
    categoryEducation: '教育学习',
    categoryLifestyle: '生活服务',
    categoryMarketing: '营销推广',
    categoryCreative: '创意工具',
    categoryProductivity: '效率工具',
    categoryCommunity: '社区',
    categoryDevTools: '开发工具',

    tools: [
      { name: 'Tool Search', description: 'AI驱动的开源工具搜索引擎，不需要背工具名，自然语言搜索即可找到最适合的工具', category: '效率工具' },
      { name: 'Movie Search', description: '电影推荐工具 - 根据你的喜好、心情、场景智能推荐电影，发现你的下一部最爱', category: '效率工具' },
      { name: 'Recipe Search', description: '菜谱推荐工具 - 输入食材或口味偏好，AI为你推荐完美菜谱，让每次烹饪都成为享受', category: '效率工具' },
      { name: 'Book Search', description: '书籍推荐工具 - 基于你的阅读历史和兴趣，发现值得阅读的好书，让知识滋养你的心灵', category: '效率工具' },
      { name: 'Job Search', description: '求职岗位分析 - AI分析职位描述，匹配你的技能，发现最佳工作机会，让求职更高效', category: '职业发展' },
      { name: 'Course Search', description: '在线课程推荐 - 根据你的学习目标，智能推荐优质课程，让成长之路更清晰', category: '教育学习' },
      { name: 'Podcast Market', description: '播客集市 - 文本一键转有声内容，快速创建专业播客，让声音传播你的思想', category: '内容创作' },
      { name: 'Promo Assistant', description: '推广助手 - 同频内容全球分发枢纽，精准触达目标受众，让内容价值最大化', category: '营销推广' },
      { name: 'Deep Research', description: '专业智库深度调研 - AI驱动的深度研究工具，快速获取专业洞察，助力明智决策', category: '研究分析' },
      { name: 'AI Soul Workshop', description: 'AI灵魂工坊 - 自定义人格创造平台，打造独一无二的AI角色，让创意变为现实', category: '创意工具' },
      { name: 'Thinker Lite', description: '思想者轻社区 - 无焦虑哲思分享空间，深度思考与心灵对话的精神家园', category: '社区' },
      { name: 'Open Source Hub', description: '开源生态 - 沉浸式文档与开发者枢纽，连接开源世界，让协作更简单', category: '开发工具' },
      { name: 'AI Soul Chat', description: 'AI灵魂对话 - 私密创作工坊，与AI深度对话，激发创意灵感，让思想自由流淌', category: '创意工具' },
      { name: 'Research Share', description: '研享社 - AI原生专业研究成果共享经济平台，连接研究者，让知识价值最大化', category: '研究分析' },
      { name: 'Silicon Workspace', description: '硅基协同工作台 - AI输出自动分类归入6大模块，解决碎片化痛点，让协同更高效', category: '效率工具' },
      { name: 'Bio Robot DIY', description: '儿童科普 DIY 生物机器人 - 展示系列小实验，让小朋友在家轻松探索生命科学奥秘', category: '教育学习' },
      { name: 'ACP Protocol', description: 'ACP开源协议 - Structured AI Collaboration Protocol，定义7种标准化数据结构，解决AI协同数据互通', category: '开发工具' },
      { name: 'Prototype Lab', description: '原型实验室 - 快速创建产品原型，AI自动生成交互流程，加速产品迭代', category: '设计工具' },
      { name: 'Kids Original', description: '少儿原创 - 让孩子发挥无限创意，展示原创作品，培养下一代创新者', category: '教育学习' },
      { name: 'Silver Care', description: '银发互助 - 温暖的老年人互助社区，提供陪伴服务，让晚年生活更美好', category: '社区' },
      { name: 'AI Native Video', description: 'AI原生视频 - 用AI技术快速生成专业视频内容，让创作更简单高效', category: '内容创作' },
    ],

    statsTools: '精选工具',
    statsAI: 'AI驱动',
    statsOnline: '在线服务',

    footerMadeWith: 'Douya',
    footerCopyright: '© 2026 Douya Center - 把复杂留给AI，把简单留给自己',
    footerGithub: 'GitHub',
    footerFeedback: '批评建议',
  },

  // ===== English =====
  en: {
    logoSubtitle: 'A creative wilderness in the AI-native era. A space for thinkers to own their space and soul. The "home port" of a decentralized creator ecosystem. No tracking, no intrusion, no popups. No catering to traffic, no selling anxiety, no disturbing pure thinking.',
    tagline: 'AI Tool Collection',
    langName: 'English',

    heroTitle: 'AI-Driven Original Tool Collection',
    heroSubtitle: '21 curated AI tools to make your work and life more brilliant',

    growing: 'Growing',
    comingSoon: 'Coming Soon',

    categoryAll: 'All',
    categoryContentCreation: 'Content',
    categoryDesign: 'Design',
    categoryResearch: 'Research',
    categoryCareer: 'Career',
    categoryEducation: 'Education',
    categoryLifestyle: 'Lifestyle',
    categoryMarketing: 'Marketing',
    categoryCreative: 'Creative',
    categoryProductivity: 'Productivity',
    categoryCommunity: 'Community',
    categoryDevTools: 'Dev Tools',

    tools: [
      { name: 'Tool Search', description: 'AI-powered open source tool search. Find the perfect tools with natural language', category: 'Productivity' },
      { name: 'Movie Search', description: 'Movie recommendations based on your mood and taste. Discover your next favorite', category: 'Productivity' },
      { name: 'Recipe Search', description: 'Enter ingredients, AI recommends perfect recipes for enjoyable cooking', category: 'Productivity' },
      { name: 'Book Search', description: 'Discover worthy reads based on your interests. Let knowledge nourish your soul', category: 'Productivity' },
      { name: 'Job Search', description: 'AI analyzes job descriptions, matches your skills, finds the best opportunities', category: 'Career' },
      { name: 'Course Search', description: 'AI recommends quality courses based on your learning goals', category: 'Education' },
      { name: 'Podcast Market', description: 'Text to audio in one click. Create professional podcasts and spread your ideas', category: 'Content' },
      { name: 'Promo Assistant', description: 'Global content distribution hub. Reach target audiences precisely', category: 'Marketing' },
      { name: 'Deep Research', description: 'AI-powered professional research. Get insights quickly for informed decisions', category: 'Research' },
      { name: 'AI Soul Workshop', description: 'Custom personality creation platform. Create unique AI characters', category: 'Creative' },
      { name: 'Thinker Lite', description: 'Anxiety-free philosophical sharing space. A spiritual home for deep thinking', category: 'Community' },
      { name: 'Open Source Hub', description: 'Immersive docs and developer portal. Connect the open source world', category: 'Dev Tools' },
      { name: 'AI Soul Chat', description: 'Private creative workshop. Deep dialogue with AI to spark inspiration', category: 'Creative' },
      { name: 'Research Share', description: 'AI-native research sharing platform. Connect researchers', category: 'Research' },
      { name: 'Silicon Workspace', description: 'AI output auto-categorized into 6 modules. Solve fragmentation for efficiency', category: 'Productivity' },
      { name: 'Bio Robot DIY', description: 'Kids science popularization. Explore life science at home', category: 'Education' },
      { name: 'ACP Protocol', description: 'Structured AI Collaboration Protocol. Defines 7 data structures for AI interoperability', category: 'Dev Tools' },
      { name: 'Prototype Lab', description: 'Quickly create prototypes. AI auto-generates interaction flows', category: 'Design' },
      { name: 'Kids Original', description: 'Let children unleash creativity, showcase original works', category: 'Education' },
      { name: 'Silver Care', description: 'Warm elderly mutual aid community. Better later life', category: 'Community' },
      { name: 'AI Native Video', description: 'Generate professional video content with AI. Simpler and more efficient', category: 'Content' },
    ],

    statsTools: 'Curated Tools',
    statsAI: 'AI-Powered',
    statsOnline: 'Online Service',

    footerMadeWith: 'Douya',
    footerCopyright: '© 2026 Douya Center - Leave complexity to AI, keep simplicity for yourself',
    footerGithub: 'GitHub',
    footerFeedback: 'Feedback',
  },

  // ===== Deutsch (German) =====
  de: {
    logoSubtitle: 'Eine kreative Wildnis im AI-native Zeitalter. Ein Raum für Denker, ihren Raum und ihre Seele zu besitzen. Der "Heimathafen" eines dezentralen Creator-Ökosystems. Kein Tracking, keine Störung, keine Popups. Keine Anpassung an Traffic, kein Verkauf von Angst, keine Störung reinen Denkens.',
    tagline: 'KI-Tools',
    langName: 'Deutsch',

    heroTitle: 'KI-gesteuerte originale Tool-Sammlung',
    heroSubtitle: '21 kuratierte KI-Tools für work und life',

    growing: 'Im Wachstum',
    comingSoon: 'Demnächst',

    categoryAll: 'Alle',
    categoryContentCreation: 'Content',
    categoryDesign: 'Design',
    categoryResearch: 'Forschung',
    categoryCareer: 'Karriere',
    categoryEducation: 'Bildung',
    categoryLifestyle: 'Lifestyle',
    categoryMarketing: 'Marketing',
    categoryCreative: 'Kreativ',
    categoryProductivity: 'Produktivität',
    categoryCommunity: 'Community',
    categoryDevTools: 'Dev Tools',

    tools: [
      { name: 'Tool Search', description: 'KI-gesteuerte Open-Source-Tool-Suche. Finden Sie die perfekten Tools mit natürlicher Sprache', category: 'Produktivität' },
      { name: 'Movie Search', description: 'Filmbasierte Empfehlungen nach Stimmung und Geschmack. Entdecken Sie Ihren neuen Lieblingsfilm', category: 'Produktivität' },
      { name: 'Recipe Search', description: 'Zutaten eingeben, KI empfiehlt perfekte Rezepte', category: 'Produktivität' },
      { name: 'Book Search', description: 'Entdecken Sie wertvolle Bücher basierend auf Ihren Interessen', category: 'Produktivität' },
      { name: 'Job Search', description: 'KI analysiert Stellenbeschreibungen,匹配您的技能', category: 'Karriere' },
      { name: 'Course Search', description: 'KI empfiehlt Qualitätskurse basierend auf Ihren Lernzielen', category: 'Bildung' },
      { name: 'Podcast Market', description: 'Text zu Audio in einem Klick. Erstellen Sie professionelle Podcasts', category: 'Content' },
      { name: 'Promo Assistant', description: 'Globaler Content-Verteilungshub. Erreichen Sie Zielgruppen präzise', category: 'Marketing' },
      { name: 'Deep Research', description: 'KI-gesteuerte professionelle Forschung. Erhalten Sie Einblicke schnell', category: 'Forschung' },
      { name: 'AI Soul Workshop', description: 'Plattform für benutzerdefinierte Persönlichkeiten. Erstellen Sie einzigartige KI-Charaktere', category: 'Kreativ' },
      { name: 'Thinker Lite', description: 'Angstfreier philosophischer Raum. Ein geistiges Zuhause für tiefes Denken', category: 'Community' },
      { name: 'Open Source Hub', description: 'Immersive Docs und Entwickler-Portal. Verbinden Sie die Open-Source-Welt', category: 'Dev Tools' },
      { name: 'AI Soul Chat', description: 'Privater kreativer Workshop. Tiefer Dialog mit KI für Inspiration', category: 'Kreativ' },
      { name: 'Research Share', description: 'KI-native Forschungsplattform. Verbinden Sie Forscher', category: 'Forschung' },
      { name: 'Silicon Workspace', description: 'KI-Output automatisch in 6 Module kategorisiert. Effizienz durch Struktur', category: 'Produktivität' },
      { name: 'Bio Robot DIY', description: 'Kinder-Wissenschaft. Entdecken Sie Biologie zu Hause', category: 'Bildung' },
      { name: 'ACP Protocol', description: 'Structured AI Collaboration Protocol. Definiert 7 Datenstrukturen für KI-Interoperabilität', category: 'Dev Tools' },
      { name: 'Prototype Lab', description: 'Erstellen Sie schnell Prototypen. KI generiert Interaktionsflüsse automatisch', category: 'Design' },
      { name: 'Kids Original', description: 'Lassen Sie Kinder Kreativität entfalten, originelle Werke präsentieren', category: 'Bildung' },
      { name: 'Silver Care', description: 'Warme gegenseitige Hilfe-Community für Senioren. Bessere Lebensqualität', category: 'Community' },
      { name: 'AI Native Video', description: 'Erstellen Sie professionelle Videoinhalte mit KI. Einfacher und effizienter', category: 'Content' },
    ],

    statsTools: 'Kuratierte Tools',
    statsAI: 'KI-gesteuert',
    statsOnline: 'Online-Service',

    footerMadeWith: 'Douya',
    footerCopyright: '© 2026 Douya Center - Komplexität der KI überlassen, Einfachheit für sich behalten',
    footerGithub: 'GitHub',
    footerFeedback: 'Feedback',
  },

  // ===== Français (French) =====
  fr: {
    logoSubtitle: 'Une nature sauvage créative à l\'ère AI-native. Un espace pour les penseurs. Le "port d\'attache" d\'un écosystème créateur décentralisé. Pas de tracking, pas d\'intrusion, pas de popups. Pas de迎合 de trafic, pas de vente d\'anxiété, pas de perturbation de la pensée pure.',
    tagline: 'Collection IA',
    langName: 'Français',

    heroTitle: 'Collection d\'outils originaux alimentés par l\'IA',
    heroSubtitle: '21 outils IA sélectionnés pour améliorer votre travail et votre vie',

    growing: 'En croissance',
    comingSoon: 'À venir',

    categoryAll: 'Tous',
    categoryContentCreation: 'Contenu',
    categoryDesign: 'Design',
    categoryResearch: 'Recherche',
    categoryCareer: 'Carrière',
    categoryEducation: 'Éducation',
    categoryLifestyle: 'Mode de vie',
    categoryMarketing: 'Marketing',
    categoryCreative: 'Créatif',
    categoryProductivity: 'Productivité',
    categoryCommunity: 'Communauté',
    categoryDevTools: 'Outils Dev',

    tools: [
      { name: 'Tool Search', description: 'Recherche d\'outils open source alimentée par l\'IA. Trouvez les outils parfaits en langage naturel', category: 'Productivité' },
      { name: 'Movie Search', description: 'Recommandations de films basées sur votre humeur. Découvrez votre nouveau favori', category: 'Productivité' },
      { name: 'Recipe Search', description: 'Entrez des ingrédients, l\'IA recommande des recettes parfaites', category: 'Productivité' },
      { name: 'Book Search', description: 'Découvrez des livres intéressants basés sur vos intérêts', category: 'Productivité' },
      { name: 'Job Search', description: 'L\'IA analyse les descriptions,匹配vos compétences, trouve les meilleures opportunités', category: 'Carrière' },
      { name: 'Course Search', description: 'L\'IA recommande des cours de qualité basés sur vos objectifs d\'apprentissage', category: 'Éducation' },
      { name: 'Podcast Market', description: 'Texte vers audio en un clic. Créez des podcasts professionnels', category: 'Contenu' },
      { name: 'Promo Assistant', description: 'Hub de distribution de contenu mondial. Atteignez les publics cibles précisément', category: 'Marketing' },
      { name: 'Deep Research', description: 'Recherche professionnelle alimentée par l\'IA. Obtenez des insights rapidement', category: 'Recherche' },
      { name: 'AI Soul Workshop', description: 'Plateforme de création de personnalité personnalisée. Créez des personnages IA uniques', category: 'Créatif' },
      { name: 'Thinker Lite', description: 'Espace philosophique sans anxiété. Un foyer spirituel pour la réflexion profonde', category: 'Communauté' },
      { name: 'Open Source Hub', description: 'Docs immersifs et portail développeur. Connectez le monde open source', category: 'Outils Dev' },
      { name: 'AI Soul Chat', description: 'Atelier créatif privé. Dialogue approfondi avec l\'IA pour l\'inspiration', category: 'Créatif' },
      { name: 'Research Share', description: 'Plateforme de partage de recherche IA-native. Connectez les chercheurs', category: 'Recherche' },
      { name: 'Silicon Workspace', description: 'Sortie IA automatiquement catégorisée en 6 modules. Résoudre la fragmentation', category: 'Productivité' },
      { name: 'Bio Robot DIY', description: 'Science populaire pour enfants. Explorez la biologie à la maison', category: 'Éducation' },
      { name: 'ACP Protocol', description: 'Protocole de collaboration AI structurée. Définit 7 structures de données pour l\'interopérabilité IA', category: 'Outils Dev' },
      { name: 'Prototype Lab', description: 'Créez rapidement des prototypes. L\'IA génère automatiquement les flux d\'interaction', category: 'Design' },
      { name: 'Kids Original', description: 'Laissez les enfants libérer leur créativité, présenter des œuvres originales', category: 'Éducation' },
      { name: 'Silver Care', description: 'Communauté d\'entraide chaleureuse pour seniors. Meilleure qualité de vie', category: 'Communauté' },
      { name: 'AI Native Video', description: 'Générez du contenu vidéo professionnel avec l\'IA. Plus simple et plus efficace', category: 'Contenu' },
    ],

    statsTools: 'Outils Sélectionnés',
    statsAI: 'Alimenté par IA',
    statsOnline: 'Service en Ligne',

    footerMadeWith: 'Douya',
    footerCopyright: '© 2026 Douya Center - Laissez la complexité à l\'IA, gardez la simplicité pour vous',
    footerGithub: 'GitHub',
    footerFeedback: 'Feedback',
  },

  // ===== 日本語 (Japanese) =====
  ja: {
    logoSubtitle: 'AIネイティブ時代の創造的な荒野。思考者のための空間と魂。分散型クリエイターエコシステムの「母港」。追跡なし、侵入なし、ポップアップなし。トラフィック迎合なし、不安売りなし、純粋な思考を邪魔しない。',
    tagline: 'AIツール',
    langName: '日本語',

    heroTitle: 'AI駆動のオリジナルツールコレクション',
    heroSubtitle: '厳選された21のAIツールで、仕事と生活をより素晴らしく',

    growing: '成長中',
    comingSoon: '近日公開',

    categoryAll: 'すべて',
    categoryContentCreation: 'コンテンツ',
    categoryDesign: 'デザイン',
    categoryResearch: '研究',
    categoryCareer: 'キャリア',
    categoryEducation: '教育',
    categoryLifestyle: 'ライフスタイル',
    categoryMarketing: 'マーケティング',
    categoryCreative: 'クリエイティブ',
    categoryProductivity: '生産性',
    categoryCommunity: 'コミュニティ',
    categoryDevTools: '開発ツール',

    tools: [
      { name: 'Tool Search', description: 'AI駆動のオープンソースツール検索。自然言語で完璧なツールを見つけよう', category: '生産性' },
      { name: 'Movie Search', description: '気分や趣味に基づいた映画おすすめ。新しいお気に入りを発見', category: '生産性' },
      { name: 'Recipe Search', description: '食材を入力、AIが完璧なレシピをおすすめ', category: '生産性' },
      { name: 'Book Search', description: '興味に基づいた価値ある本を発見。知識で魂を養おう', category: '生産性' },
      { name: 'Job Search', description: 'AIが職務記述を分析、スキルをマッチング、最適な機会を見つける', category: 'キャリア' },
      { name: 'Course Search', description: '学習目標に基づいた高品質コースをAIがおすすめ', category: '教育' },
      { name: 'Podcast Market', description: 'ワンクリックでテキストから音声へ。プロフェッショナルなポッドキャストを作成', category: 'コンテンツ' },
      { name: 'Promo Assistant', description: 'グローバルコンテンツ配信ハブ。ターゲットオーディエンスに正確にリーチ', category: 'マーケティング' },
      { name: 'Deep Research', description: 'AI駆動のプロフェッショナル研究。迅速な洞察で意思決定支援', category: '研究' },
      { name: 'AI Soul Workshop', description: 'カスタムパーソナリティ作成プラットフォーム。ユニークなAIキャラクターを作成', category: 'クリエイティブ' },
      { name: 'Thinker Lite', description: '不安のない哲学的共有空間。深い思考のための精神的拠り所', category: 'コミュニティ' },
      { name: 'Open Source Hub', description: 'イマーシブドキュメントと開発者ポータル。オープンソース世界を接続', category: '開発ツール' },
      { name: 'AI Soul Chat', description: 'プライベート創作ワークショップ。AIとの深い対話でインスピレーション', category: 'クリエイティブ' },
      { name: 'Research Share', description: 'AIネイティブ研究共有プラットフォーム。研究者を接続', category: '研究' },
      { name: 'Silicon Workspace', description: 'AI出力を自動的に6モジュールに分類。断片化を解消して効率化', category: '生産性' },
      { name: 'Bio Robot DIY', description: '子供のための科学普及。自宅で生命科学を探索', category: '教育' },
      { name: 'ACP Protocol', description: 'Structured AI Collaboration Protocol。AI相互運用のための7つのデータ構造を定義', category: '開発ツール' },
      { name: 'Prototype Lab', description: '素早くプロトタイプを作成。AIが自動的にインタラクションフローを生成', category: 'デザイン' },
      { name: 'Kids Original', description: '子供の創造力を解放、オリジナル作品を発表', category: '教育' },
      { name: 'Silver Care', description: '高齢者のための温かい相互扶助コミュニティ。より良い生活', category: 'コミュニティ' },
      { name: 'AI Native Video', description: 'AIでプロフェッショナルな動画コンテンツを生成。よりシンプルに効率的に', category: 'コンテンツ' },
    ],

    statsTools: '厳選ツール',
    statsAI: 'AI駆動',
    statsOnline: 'オンラインサービス',

    footerMadeWith: 'Douya',
    footerCopyright: '© 2026 Douya Center - 複雑さはAIに、シンプルさは自分に',
    footerGithub: 'GitHub',
    footerFeedback: 'フィードバック',
  },

  // ===== 한국어 (Korean) =====
  ko: {
    logoSubtitle: 'AI 네이티브 시대의 창조적 황야. 생각하는 사람을 위한 공간과 영혼. 분산형 크리에이터 생태계의 "모항". 추적 없음, 침입 없음, 팝업 없음. 트래픽 맞춤 없음, 불안 판매 없음, 순수한 사생활 방해 없음.',
    tagline: 'AI 도구',
    langName: '한국어',

    heroTitle: 'AI 구동형 오리지널 도구 컬렉션',
    heroSubtitle: '엄선된 21개 AI 도구로 업무와 삶을 더욱 brillhante하게',

    growing: '성장 중',
    comingSoon: '출시 예정',

    categoryAll: '전체',
    categoryContentCreation: '콘텐츠',
    categoryDesign: '디자인',
    categoryResearch: '연구',
    categoryCareer: '커리어',
    categoryEducation: '교육',
    categoryLifestyle: '라이프스타일',
    categoryMarketing: '마케팅',
    categoryCreative: '창작',
    categoryProductivity: '생산성',
    categoryCommunity: '커뮤니티',
    categoryDevTools: '개발 도구',

    tools: [
      { name: 'Tool Search', description: 'AI 구동 오픈 소스 도구 검색. 자연어로 완벽한 도구 찾기', category: '생산성' },
      { name: 'Movie Search', description: '기분과 취향에 기반한 영화 추천. 새로운 좋아하는 영화 발견', category: '생산성' },
      { name: 'Recipe Search', description: '재료 입력, AI가 완벽한 레시피 추천', category: '생산성' },
      { name: 'Book Search', description: '관심사 기반 가치 있는 도서 발견. 지식으로 영양을', category: '생산성' },
      { name: 'Job Search', description: 'AI가 직무 설명 분석, 스킬 매칭, 최적 기회 발견', category: '커리어' },
      { name: 'Course Search', description: '학습 목표 기반 고품질 코스 추천', category: '교육' },
      { name: 'Podcast Market', description: '원클릭 텍스트에서 오디오로. 전문 팟캐스트 제작', category: '콘텐츠' },
      { name: 'Promo Assistant', description: '글로벌 콘텐츠 배포 허브. 타겟 오디언스 정확히 도달', category: '마케팅' },
      { name: 'Deep Research', description: 'AI 구동 전문 연구. 신속한 인사이트로 의사결정 지원', category: '연구' },
      { name: 'AI Soul Workshop', description: '커스텀 페르소나 생성 플랫폼. 독특한 AI 캐릭터 만들기', category: '창작' },
      { name: 'Thinker Lite', description: '불안 없는 철학적 공유 공간. 깊은 생각의 정신적 고향', category: '커뮤니티' },
      { name: 'Open Source Hub', description: '몰입형 문서와 개발자 포털. 오픈 소스 세계 연결', category: '개발 도구' },
      { name: 'AI Soul Chat', description: '프라이빗 창작 워크샵. AI와 심층 대화로 영감', category: '창작' },
      { name: 'Research Share', description: 'AI 네이티브 연구 공유 플랫폼. 연구자 연결', category: '연구' },
      { name: 'Silicon Workspace', description: 'AI 출력을 6개 모듈로 자동 분류. 단편화 해결로 효율성', category: '생산성' },
      { name: 'Bio Robot DIY', description: '어린이 과학 대중화. 가정에서 생명과학 탐색', category: '교육' },
      { name: 'ACP Protocol', description: 'Structured AI Collaboration Protocol. AI 상호운용을 위한 7개 데이터 구조 정의', category: '개발 도구' },
      { name: 'Prototype Lab', description: '신속한 프로토타입 제작. AI가 자동으로 상호작용 흐름 생성', category: '디자인' },
      { name: 'Kids Original', description: '어린이 창의력 해방, 오리지널 작품 발표', category: '교육' },
      { name: 'Silver Care', description: '노인을 위한 따뜻한 상호부조 커뮤니티. 더 나은 삶', category: '커뮤니티' },
      { name: 'AI Native Video', description: 'AI로 전문 비디오 콘텐츠 생성. 더 간단하고 효율적으로', category: '콘텐츠' },
    ],

    statsTools: '엄선된 도구',
    statsAI: 'AI 구동',
    statsOnline: '온라인 서비스',

    footerMadeWith: 'Douya',
    footerCopyright: '© 2026 Douya Center - 복잡함은 AI에게, 단순함은 자신에게',
    footerGithub: 'GitHub',
    footerFeedback: '피드백',
  },

  // ===== العربية (Arabic) =====
  ar: {
    logoSubtitle: 'برية خلاقة في عصر AI الأصلي. مساحة للمفكرين لامتلاك فضائهم وروحهم. "الميناء الرئيسي" لنظام المبدعين اللامركزي. لا تتبع، لا اقتحام، لا نوافذ منبثقة. لا تكييف مع حركة المرور، لا بيع القلق، لا إزعاج التفكير النقي.',
    tagline: 'مجموعة أدوات AI',
    langName: 'العربية',

    heroTitle: 'مجموعة الأدوات الأصلية المدعومة بالذكاء الاصطناعي',
    heroSubtitle: '21 أداة AI مختارة لجعل عملك وحياتك أكثر روعة',

    growing: 'نمو',
    comingSoon: 'قريباً',

    categoryAll: 'الكل',
    categoryContentCreation: 'المحتوى',
    categoryDesign: 'التصميم',
    categoryResearch: 'البحث',
    categoryCareer: 'المسيرة المهنية',
    categoryEducation: 'التعليم',
    categoryLifestyle: 'نمط الحياة',
    categoryMarketing: 'التسويق',
    categoryCreative: 'الإبداع',
    categoryProductivity: 'الإنتاجية',
    categoryCommunity: 'المجتمع',
    categoryDevTools: 'أدوات التطوير',

    tools: [
      { name: 'Tool Search', description: 'بحث أدوات المصادر المفتوحة المدعوم بالذكاء الاصطناعي. ابحث عن الأدوات المثالية باللغة الطبيعية', category: 'الإنتاجية' },
      { name: 'Movie Search', description: 'توصيات الأفلام بناءً على مزاجك وذوقك. اكتشف جديدك المفضل', category: 'الإنتاجية' },
      { name: 'Recipe Search', description: 'أدخل المكونات، يوصي الذكاء الاصطناعي بوصفات مثالية', category: 'الإنتاجية' },
      { name: 'Book Search', description: 'اكتشف كتبًا قيّمة بناءً على اهتماماتك. دع المعرفة تغذي روحك', category: 'الإنتاجية' },
      { name: 'Job Search', description: 'يحلل الذكاء الاصطناعي أوصاف الوظائف، يطابق مهاراتك، يجد أفضل الفرص', category: 'المسيرة المهنية' },
      { name: 'Course Search', description: 'يوصي الذكاء الاصطناعي بدورات عالية الجودة بناءً على أهداف تعلمك', category: 'التعليم' },
      { name: 'Podcast Market', description: 'النص إلى الصوت بنقرة واحدة. أنشئ ملفات podcast احترافية', category: 'المحتوى' },
      { name: 'Promo Assistant', description: 'محور توزيع المحتوى العالمي. الوصول للجماهير المستهدفة بدقة', category: 'التسويق' },
      { name: 'Deep Research', description: 'بحث مهني مدعوم بالذكاء الاصطناعي. احصل على رؤى بسرعة', category: 'البحث' },
      { name: 'AI Soul Workshop', description: 'منصة إنشاء شخصية مخصصة. أنشئ شخصيات AI فريدة', category: 'الإبداع' },
      { name: 'Thinker Lite', description: 'مشاركة فلسفية بلا قلق. منزل روحي للتفكير العميق', category: 'المجتمع' },
      { name: 'Open Source Hub', description: 'المستندات الغامرة وبوابة المطورين. تواصل مع عالم المصادر المفتوحة', category: 'أدوات التطوير' },
      { name: 'AI Soul Chat', description: 'ورشة إبداعية خاصة. حوار عميق مع الذكاء الاصطناعي للإلهام', category: 'الإبداع' },
      { name: 'Research Share', description: 'منصة مشاركة البحث AI الأصلية. تواصل الباحثين', category: 'البحث' },
      { name: 'Silicon Workspace', description: 'مخرجات AI مصنفة تلقائيًا في 6 وحدات. حل التشتت للكفاءة', category: 'الإنتاجية' },
      { name: 'Bio Robot DIY', description: 'علم شعبي للأطفال. استكشف علم الأحياء في المنزل', category: 'التعليم' },
      { name: 'ACP Protocol', description: 'بروتوكول التعاون AI المنظم. يحدد 7 هياكل بيانات للتشغيل البيني AI', category: 'أدوات التطوير' },
      { name: 'Prototype Lab', description: 'أنشئ نماذج أولية بسرعة. ينشئ الذكاء الاصطناعي تدفقات التفاعل تلقائيًا', category: 'التصميم' },
      { name: 'Kids Original', description: 'دع الأطفال يطلقون العنان للإبداع، يعرضون أعمالًا أصلية', category: 'التعليم' },
      { name: 'Silver Care', description: 'مجتمع مساعدة متبادلة دافئ للكبار. جودة حياة أفضل', category: 'المجتمع' },
      { name: 'AI Native Video', description: 'أنشئ محتوى فيديو احترافي بالذكاء الاصطناعي. أبسط وأكثر كفاءة', category: 'المحتوى' },
    ],

    statsTools: 'أدوات مختارة',
    statsAI: 'مدعوم بالذكاء الاصطناعي',
    statsOnline: 'خدمة أونلاين',

    footerMadeWith: 'Douya',
    footerCopyright: '© 2026 Douya Center - اترك التعقيد للذكاء الاصطناعي، احتفظ بالبساطة لنفسك',
    footerGithub: 'GitHub',
    footerFeedback: 'ملاحظات',
  },
};

export const getCategories = (lang: Language): string[] => {
  const t = translations[lang];
  return [
    t.categoryAll,
    t.categoryContentCreation,
    t.categoryDesign,
    t.categoryResearch,
    t.categoryCareer,
    t.categoryEducation,
    t.categoryLifestyle,
    t.categoryMarketing,
    t.categoryCreative,
    t.categoryProductivity,
    t.categoryCommunity,
    t.categoryDevTools,
  ];
};

// 浏览器语言检测
export function detectBrowserLanguage(): Language {
  const browserLang = navigator.language || (navigator as any).userLanguage;

  // 语言映射
  const langMap: Record<string, Language> = {
    'zh': 'zh',
    'zh-CN': 'zh',
    'zh-TW': 'zh',
    'en': 'en',
    'en-US': 'en',
    'en-GB': 'en',
    'de': 'de',
    'de-DE': 'de',
    'de-AT': 'de',
    'de-CH': 'de',
    'fr': 'fr',
    'fr-FR': 'fr',
    'fr-CA': 'fr',
    'ja': 'ja',
    'ja-JP': 'ja',
    'ko': 'ko',
    'ko-KR': 'ko',
    'ar': 'ar',
    'ar-SA': 'ar',
    'ar-AE': 'ar',
    'ar-EG': 'ar',
  };

  // 尝试精确匹配
  if (langMap[browserLang]) {
    return langMap[browserLang];
  }

  // 尝试前缀匹配
  const prefix = browserLang.split('-')[0];
  if (langMap[prefix]) {
    return langMap[prefix];
  }

  // 默认返回英文
  return 'en';
}

// 支持的所有语言
export const allLanguages: { code: Language; name: string; nativeName: string }[] = [
  { code: 'zh', name: 'Chinese', nativeName: '中文' },
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'de', name: 'German', nativeName: 'Deutsch' },
  { code: 'fr', name: 'French', nativeName: 'Français' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語' },
  { code: 'ko', name: 'Korean', nativeName: '한국어' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية' },
];
